import React from 'react';
import { Wand2, Lock } from 'lucide-react';

/** Empty-state card shown when a chapter has no draft yet.
 *  The button is gated by `canGenerate` so contributors don't see an
 *  AI Draft action they can't actually invoke. */
export function EmptyState({ onGenerate, canGenerate = true }) {
  return (
    <div className="rounded-md border border-dashed border-panel-border bg-card/40 p-8 text-center not-italic">
      <Wand2 className="mx-auto h-6 w-6 text-primary/70" />
      <p className="mt-3 font-sans text-sm text-foreground/80">This chapter has not been drafted yet.</p>
      <p className="font-sans text-[13.5px] text-muted-foreground">
        {canGenerate
          ? 'Use Claude to generate a first draft, or write it yourself.'
          : 'AI drafting is disabled for your role. You can still write it yourself.'}
      </p>
      <button
        onClick={onGenerate}
        disabled={!canGenerate}
        title={canGenerate ? '' : 'Your role does not have AI generation rights.'}
        data-testid="editor-empty-draft-btn"
        className="mt-4 inline-flex items-center gap-1.5 rounded-sm bg-primary px-3 py-1.5 font-sans text-[13.5px] font-medium text-primary-foreground hover:bg-primary/90 shadow-inset-top disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary"
      >
        {!canGenerate && <Lock className="h-3.5 w-3.5" />} Draft this chapter
      </button>
    </div>
  );
}
